<style scoped>
@import url("../../../assets/sanger.css");
</style>
<style scoped lang="scss">
.deliverables-box{
  .required{
    p{
    line-height: 2;
    }
    .pre-line{
      white-space: pre-line;
    }
  }
  
}

</style>
<template>
  <div class="deliverables-box">
    <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img :src="require(`@/assets/images/gene_second/deliverables_bg.png`)" class="img-fluid" alt="擎科生物-提供及时、准确的基因合成服务">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p class="fb">发货产物：</p>
            <p class="pre-line">{{ products }}</p>
            <template v-if="reports">
              <p class="fb">电子报告：</p>
              <p class="pre-line">{{ reports }}</p>
            </template>     
          </div>
        </el-col>
      </el-row>
  </div>
</template>

<script>
export default {
  name: "gene-deliverables",
  props: {
    products: {
      type: String,
    },
    reports: {
      type: String,
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/products/gene-components/geneDeliverables.vue